export enum ClinicalHistoryCommunicationSettingType {
    SendConfirmationToPatientWithoutHistory = 0,
    SendReminderToPatientWithoutHistory, 
    SendConfirmationToPatient,
    SendReminderToPatient,
    PrivacyNoticeEnable,
    ConsentLetterEnable,
    ClinicalHistoryEnable,
}
